import { Controller } from "@hotwired/stimulus"

// Closes a <details> dropdown on an outside click or Escape — the two things a
// native <details> doesn't do on its own.
// Usage: <details data-controller="disclosure"> … </details>
export default class extends Controller {
  connect() {
    this.onClick = (event) => { if (!this.element.contains(event.target)) this.close() }
    this.onKeydown = (event) => { if (event.key === "Escape") this.close() }
    document.addEventListener("click", this.onClick)
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.onClick)
    document.removeEventListener("keydown", this.onKeydown)
  }

  close() {
    this.element.open = false
  }
}
